var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChileFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0109 14.2676C29.0109 16.1344 28.6432 17.983 27.9288 19.7077C27.2144 21.4324 26.1673 22.9996 24.8472 24.3196C23.5272 25.6397 21.96 26.6868 20.2353 27.4012C18.5106 28.1156 16.662 28.4834 14.7951 28.4834C12.9283 28.4834 11.0797 28.1156 9.35499 27.4012C7.63025 26.6868 6.06311 25.6397 4.74306 24.3196C3.423 22.9996 2.37587 21.4324 1.66146 19.7077C0.947048 17.983 0.579346 16.1344 0.579346 14.2676L14.7951 14.2676H29.0109Z",
    fill: "#D21F35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.579147 14.2676C0.579147 12.4008 0.946849 10.5522 1.66126 8.82745C2.37567 7.10271 3.4228 5.53557 4.74286 4.21551C6.06292 2.89545 7.63006 1.84833 9.3548 1.13392C11.0795 0.419506 12.9281 0.0518041 14.7949 0.0518043L14.7949 14.2676L0.579147 14.2676Z",
    fill: "#164995"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7951 0.0518048C16.662 0.0518047 18.5106 0.419507 20.2353 1.13392C21.96 1.84833 23.5272 2.89546 24.8472 4.21552C26.1673 5.53557 27.2144 7.10271 27.9288 8.82745C28.6432 10.5522 29.0109 12.4008 29.0109 14.2676L14.7951 14.2676L14.7951 0.0518048Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90717 4.95703L9.77797 7.63708H12.5959L10.3162 9.29344L11.187 11.9735L8.90717 10.3171L6.62738 11.9735L7.49818 9.29344L5.2184 7.63708H8.03637L8.90717 4.95703Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChileFlag);
export default __webpack_public_path__ + "static/media/chileFlag.43d02176acf38636bede6f0093ec31f1.svg";
export { ForwardRef as ReactComponent };